import { memo } from 'react';
import { useAsync } from 'react-use';
import TournamentService from '@zmedia/bm-soccer-ui/service/TournamentService';
import { Element, IconButton, Title } from '@zmedia/bm-soccer-ui/components';
import { StatsPlayer } from '..';
import styles from './style.module.scss';


function ModalStatsPlayer(props: any) {
    const { id, seasonId, hide, type } = props;
    const state = useAsync(
        () =>
            TournamentService.getRankingDetail({
                seasonId: seasonId,
                tournamentId: id,
                type: type.id,
            }),
        [seasonId, id]
    );

    const data = state.value?.data || {};

    const { items = [] } = data;

    return (
        <Element className={styles['stats-player-modal']}>
            <IconButton icon="close" title='Đóng' onClick={hide} />
            <Title>{type.name}</Title>
            <StatsPlayer items={items} />
        </Element>
    );
}

export default memo(ModalStatsPlayer);
